import frBlogPosts from "./blogPosts.json";
import frBghUrteile from "./bghUrteile.json";
import frCalculator from "./calculator.json";
import frCommon from "./common.json";
import frDialogs from "./dialogs.json";
import frExpertise from "./expertise.json";
import frExpertiseSolutions from "./expertiseSolutions.json";
import frFaqs from "./faqs.json";
import frFooter from "./footer.json";
import frHome from "./home.json";
import frJudgmentsLanding from "./judgmentsLanding.json";
import frLandingpages from "./landingpages.json";
import frNav from "./nav.json";
import frReferences from "./references.json";
import frSolvingTax from "./solvingTax.json";
import frTeam from "./team.json";

/** Merged onto `deCatalog` via `mergeDeep` in `buildCatalog` (no `expertiseCity` — inherits DE). */
export const frMessageOverlay = {
  nav: frNav,
  footer: frFooter,
  home: frHome,
  common: frCommon,
  dialogs: frDialogs,
  expertise: frExpertise,
  blogPosts: frBlogPosts,
  expertiseSolutions: frExpertiseSolutions,
  team: frTeam,
  references: frReferences,
  landingpages: frLandingpages,
  solvingTax: frSolvingTax,
  bghUrteile: frBghUrteile,
  faqs: frFaqs,
  calculator: frCalculator,
  judgmentsLanding: frJudgmentsLanding,
} as const;
